export const galleryData = [
  {
    id: 1,
    category: 'demolition',
    title: 'Professional Building Demolition',
    image: '/new_image/Buiding Demolish.jpg',
    description: 'Safe and controlled building demolition services in Coimbatore'
  },
  {
    id: 2,
    category: 'earthwork',
    title: 'Expert Excavation & Site Preparation',
    image: '/new_image/Excavator for rent.jpg',
    description: 'Expert excavation, site preparation and foundation work across Coimbatore'
  },
  {
    id: 3,
    category: 'materials',
    title: 'Best Building Material Suppliers',
    image: '/new_image/Building materials.jpg',
    description: 'Premium quality building materials supplied across Coimbatore'
  },
  {
    id: 4,
    category: 'completed',
    title: 'Civil Construction Services',
    image: '/new_image/Excavator breaker for rent.jpg',
    description: 'Comprehensive civil construction solutions in Coimbatore'
  },
  {
    id: 5,
    category: 'completed',
    title: 'Trusted Civil Construction Partner',
    image: '/new_image/JCB for rent.jpg',
    description: 'Your trusted civil construction partner in Coimbatore'
  },
  {
    id: 6,
    category: 'completed',
    title: 'Established Civil Supplier',
    image: '/new_image/Bobcat for rent.jpg',
    description: "Coimbatore's most trusted name in building demolition, earthwork and materials supply"
  },
  {
    id: 7,
    category: 'earthwork',
    title: 'Excavator Operations',
    image: '/new_image/Excavator for rent.jpg',
    description: 'Heavy excavator operations for earthwork projects in Coimbatore'
  },
  {
    id: 8,
    category: 'earthwork',
    title: 'JCB Earthwork Services',
    image: '/new_image/JCB for rent.jpg',
    description: 'JCB machinery for efficient earthwork and excavation in Coimbatore'
  },
  {
    id: 9,
    category: 'completed',
    title: 'Why Choose Sri Krish',
    image: '/new_image/Building materials.jpg',
    description: '15+ years of excellence in civil construction across Coimbatore'
  }
];

export const galleryCategories = [
  { id: 'all', name: 'All Projects' },
  { id: 'demolition', name: 'Building Demolition' },
  { id: 'earthwork', name: 'Earthwork' },
  { id: 'materials', name: 'Building Materials' },
  { id: 'completed', name: 'Completed Projects' }
];
